import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { Router } from '@angular/router';
import { CaasError404 } from '../../../shared/interfaces/caas/caas.interface';
import { CaasRoutesService } from '../../../services/caas-routes.service';
import { ImagesService } from '../../../services/images.service';
import { CapitalizePipe } from '../../capitalize.pipe';
import { safeAssign } from '../../../shared/utils/safe-assign.util';
import { ErrorHandlerService } from '../../../services/error-handler.service';

@Component({
  selector: 'hdi-not-found-box',
  standalone: true,
  imports: [ButtonComponent, CommonModule, CapitalizePipe],
  templateUrl: './not-found-box.component.html',
  styleUrls: ['./not-found-box.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class NotFoundBoxComponent implements OnChanges {
  @Input() caasData?: CaasError404;
  @Input() title?: string;
  @Input() description?: string;
  @Input() imageUrl?: string;
  @Input() alt: string = '';
  @Input() linkLabel?: string;
  @Input() linkUrl?: string;
  @Input() errorCode?: '404' | '500';
  public readonly ButtonType = ButtonType;
  public imageAlt: string = '';
  constructor(
    private readonly router: Router,
    private readonly caasRoutesService: CaasRoutesService,
    private readonly imagesService: ImagesService,
    private readonly errorHandler: ErrorHandlerService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      safeAssign(
        () => {
          if (this.caasData?.formData?.st_bodytext?.value) {
            this.description = this.caasData.formData.st_bodytext.value;
          }
        },
        'Assigning not found box description',
        this.errorHandler
      );
      safeAssign(
        () => {
          if (this.caasData?.formData?.st_header?.value) {
            this.title = this.caasData.formData.st_header.value;
          }
        },
        'Assigning not found box title',
        this.errorHandler
      );
      safeAssign(
        () => {
          if (this.caasData?.formData?.st_image?.value?.url) {
            this.imageUrl = this.caasData.formData.st_image.value.url;
            this.imageAlt =
              this.imagesService.getAltTextById(
                this.caasData.formData.st_image.value.identifier ?? ''
              ) ?? '';
          }
        },
        'Assigning not found box image',
        this.errorHandler
      );
      safeAssign(
        () => {
          if (
            this.caasData?.formData?.st_link?.value?.formData?.lt_link_label
              ?.value
          ) {
            this.linkLabel =
              this.caasData.formData.st_link.value.formData.lt_link_label.value;
          }
        },
        'Assigning not found box link label',
        this.errorHandler
      );
      safeAssign(
        () => {
          if (
            this.caasData?.formData?.st_link?.value?.formData?.lt_link_internal
              ?.value?.uid
          ) {
            this.linkUrl =
              this.caasRoutesService.getSeoRouteByIdentifier(
                this.caasData?.formData.st_link.value.formData.lt_link_internal
                  .value.identifier,
                this.router.config
              )?.path ?? '404';
          }
        },
        'Assigning not found box link internal',
        this.errorHandler
      );
    }
  }
}
